import axiosClient from './axiosClient';
import { IApiBaseResponse } from '~/utils/interface/common';
import {
  IParamsAccountSelection,
  IParamsGetAccounts,
  IParamsGetSelectAccounts,
  IPayloadDeleteAccount,
  IResponseGetAccount,
  IResponseGetAccounts,
  IResponseGetSelectAccounts,
} from '~/utils/interface/account';
import { IResponseAccount, IAccount } from '~/utils/interface/account';

const accountApi = {
  getSelectAccounts(params: IParamsGetSelectAccounts) {
    return axiosClient.get<IApiBaseResponse<IResponseGetSelectAccounts>>('api/admin/accounts/selection', { params });
  },

  createAccount(data: IAccount) {
    return axiosClient.post<IApiBaseResponse<IResponseAccount>>('api/admin/accounts', data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
  getAccounts(params: IParamsGetAccounts) {
    const url = `api/admin/accounts`;
    return axiosClient.get<IApiBaseResponse<IResponseGetAccounts>>(url, { params });
  },
  getAccount(id: string) {
    return axiosClient.get<IApiBaseResponse<IResponseGetAccount>>(`api/admin/accounts/${id}`);
  },
  updateAccount(id: string | undefined, data: IAccount) {
    return axiosClient.put<IApiBaseResponse<IResponseAccount>>(`api/admin/accounts/${id}`, data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
  deleteAccount(data: IPayloadDeleteAccount) {
    const url = `api/admin/accounts`;
    return axiosClient.delete<IApiBaseResponse<null>>(url, { data });
  },
  getAccountsSelection(params: IParamsAccountSelection) {
    return axiosClient.get<IApiBaseResponse<IResponseGetSelectAccounts>>('api/admin/accounts/selection', { params });
  },
};

export default accountApi;
